import { createAsyncThunk } from '@reduxjs/toolkit';
import chevron from '@/services/chevron';
import { showToast } from '../notifications/slice';
import type { User } from './types';

export const USER_PATH = 'account/v1/users/current';

export const fetchUser = createAsyncThunk<User, void>(
  'user/fetchUser',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = (await chevron.http({
        url: `${import.meta.env.VITE_API_MAIN_APP}/${USER_PATH}`,
        method: 'GET',
      })) as User;

      if (!response) {
        return rejectWithValue('Failed to fetch user');
      }
      return response;
    } catch (e) {
      console.warn(e);
      dispatch(showToast({ text: 'Failed to fetch user', state: 'warning' }));
      return rejectWithValue('Failed to fetch user');
    }
  },
);
